import { render, staticRenderFns } from "./FilterDeviceLabel.vue?vue&type=template&id=b8c979bc&scoped=true"
import script from "./FilterDeviceLabel.vue?vue&type=script&lang=ts"
export * from "./FilterDeviceLabel.vue?vue&type=script&lang=ts"
import style0 from "./FilterDeviceLabel.vue?vue&type=style&index=0&id=b8c979bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c979bc",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/filter/filter-device.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2FFilterDeviceLabel.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports